import React, { useEffect, useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Typography,
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { isMobile } from 'utils/screen';
import { ListingContext } from 'contexts';
import { HvIconButton, HvButton } from 'components';
import { BaseHeader } from 'pages/shared';
import { Picture } from 'models';
import { COLOR } from 'config/constants';

import 'styles/animations.scss';

const useStyles = makeStyles({
  houseInfo: {
    fontSize: '12px',
    lineHeight: '14px',
    marginLeft: '10px',

    '@media (max-width: 767px)': {
      display: 'none',
    },
  },
  iconButton: {
    width: 'max-content',
    minWidth: 'auto',
    color: '#4E575F',
    marginLeft: '10px',
    fontFamily: 'Ford Antenna',
    '&:first-child': {
      marginLeft: 0,
    },
    '@media (max-width: 767px)': {
      width: 8,
    },
    '& p': {
      '@media (max-width: 991px)': {
        display: 'none',
      },
    },
  },
  blueButton: {
    width: 'max-content',
    minWidth: 'auto',
    backgroundColor: COLOR.LIGHT_BLUE,
    color: COLOR.WHITE,
    marginLeft: '10px',
    fontFamily: 'Ford Antenna',
    '&:first-child': {
      marginLeft: 0,
    },
    '@media (max-width: 767px)': {
      width: 8,
    },
    '& p': {
      '@media (max-width: 991px)': {
        display: 'none',
      },
    },
  },
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
  },
});

function Header() {
  const intl = useIntl();
  const styles = useStyles();
  const { listing, onDownloadAll, checkIfLogedIn, public_usage, onClickShare } =
    useContext(ListingContext);
  const [warningDownloadDialog, setWarningDownloadDialog] = useState(false);
  const fmtDownloadAll = intl.formatMessage({ id: 'downloadAll' });
  const fmtShareWithClients = intl.formatMessage({ id: 'shareWithClients' });

  const [isExchangeAvailable, setIsExchangeAvailable] = useState(false);

  const left = (
    <Typography classes={{ root: styles.houseInfo }}>{listing?.cityAddress || ''}</Typography>
  );

  useEffect(() => {
    if (listing.pictures) {
      const deliveredPictures = listing.pictures.filter((picture: Picture) => {
        return picture.show_watermark === false;
      });

      for (let i = 0; i < deliveredPictures.length; i++) {
        if (deliveredPictures[i].was_downloaded === false) {
          setIsExchangeAvailable(true);
          break;
        }
      }
    }
  });

  const right = (
    <>
      <Dialog
        open={warningDownloadDialog}
        onClose={() => {
          setWarningDownloadDialog(false);
        }}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {intl.formatMessage({ id: 'deliver.photos.warning' })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {intl.formatMessage({ id: 'deliver.photos.downloadWarning' })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <HvButton
            className={styles.cancelButton}
            onClick={() => {
              setWarningDownloadDialog(false);
            }}
          >
            {intl.formatMessage({ id: 'deliver.photos.cancel' })}
          </HvButton>
          <HvButton
            onClick={() => {
              onDownloadAll();
              setWarningDownloadDialog(false);
            }}
          >
            {intl.formatMessage({ id: 'deliver.photos.accept' })}
          </HvButton>
        </DialogActions>
      </Dialog>
      {!public_usage && (
        <>
          <HvIconButton
            className={styles.blueButton}
            icon='share'
            text={fmtShareWithClients}
            onClick={() => {
              return onClickShare();
            }}
          />

          <HvIconButton
            className={styles.iconButton}
            icon='download'
            text={fmtDownloadAll}
            onClick={() => {
              if (checkIfLogedIn()) {
                if (isExchangeAvailable) {
                  setWarningDownloadDialog(true);
                } else {
                  onDownloadAll();
                }
              }
            }}
          />
        </>
      )}
    </>
  );

  return (
    <BaseHeader left={left} rightBefore={right} public_usage={public_usage} showLanguageMenu />
  );
}

export default Header;
